<template>
	<div class="edit">
		<div class="edit__label">{{ label }} <span v-if="!optional">*</span></div>
		<input ref="inp" :type="password ? 'password' : 'text'" v-bind:value="value" @input="$emit('input', $event.target.value)" @keyup.enter="$emit('enter')" />
		<div v-if="suffix" class="suffix">{{ suffix }}</div>
	</div>
</template>

<script>
	export default {
		props: {
			password: Boolean,
			name: String,
			label: String,
			value: [String, Number],
			optional: Boolean,
			weight: {
				type: Number,
				default: 1
			},
			suffix: {
				type: String,
				default: null
			}
		},
		methods: {
			focus() {
				this.$refs.inp.$el.focus();
			}
		}
	}
</script>

<style lang="scss">
	.edit {
		position: relative;
		height: 52px;

		&__label {
			position: absolute;
			pointer-events: none;
			left: 0;
			top: 0;
			font-size: 12px;
			color: #555963;

			& > span {
				color: #f7223f;
				font-size: 12px;
			}
		}

		& > input {
			position: absolute;
			left: 0;
			bottom: 0;
			height: 30px;
			background-color: #202127;
			width: 100%;
			color: white;
			font-size: 14px;
			padding-left: 5px;
		}

		& > .suffix {
			position: absolute;
			right: 0;
			bottom: 0;
			height: 30px;
			line-height: 30px;
			color: white;
			font-size: 14px;
			padding-right: 5px;
		}
	}
</style>